var chunkToChildrenMap = {
	"50": [
		295
	],
	"155": [
		530,
		862
	],
	"188": [
		121
	],
	"559": [
		530
	],
	"907": [
		297
	],
	"961": [
		939
	],
	"963": [
		889
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));